// AppLovin Axon pixel helper. The base snippet (init) lives in public/index.html so it loads on every route;
// this file only fires named events. Never throws, never blocks the UI.

const call = (...args) => {
  try {
    if (typeof window !== "undefined" && typeof window.axon === "function") window.axon(...args);
  } catch { /* pixel offline */ }
};

export const axonTrack = (name, params) => (params ? call("track", name, params) : call("track", name));

// One page_view per route change (guards React StrictMode's double effect in dev and accidental double mounts).
let lastView = { path: null, at: 0 };
export const axonPageView = () => {
  const path = typeof window !== "undefined" ? window.location.pathname + window.location.search : "";
  const now = Date.now();
  if (path === lastView.path && now - lastView.at < 1000) return;
  lastView = { path, at: now };
  axonTrack("page_view");
};

// Signup, demo request, contact / lead form submitted successfully.
export const axonLead = (source) => axonTrack("generate_lead", source ? { source } : undefined);

// Checkout started. `data` is the backend checkout response (amount_usd / monthly_price_usd when known).
export const axonBeginCheckout = (data = {}, extra = {}) => {
  const value = Number(data.amount_usd ?? data.monthly_price_usd);
  axonTrack("begin_checkout", { currency: "USD", ...(Number.isFinite(value) ? { value } : {}), ...extra });
};

// Paid. De-duplicated per Stripe session so a refresh of the success page never double-counts.
export const axonPurchase = (sessionId, value, extra = {}) => {
  try {
    const key = `axon_purchase_${sessionId}`;
    if (sessionId && window.sessionStorage.getItem(key)) return;
    if (sessionId) window.sessionStorage.setItem(key, "1");
  } catch { /* storage blocked — fire anyway */ }
  const v = Number(value);
  axonTrack("purchase", { currency: "USD", ...(Number.isFinite(v) ? { value: v } : {}), ...(sessionId ? { transaction_id: sessionId } : {}), ...extra });
};
